import GaleryPhoto from './GaleryPhoto';

export default GaleryPhoto;
